import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';

export const getAppsVersions = createAsyncThunk(
    'servicesAppsVersions/getAppsVersions',
    async (data, { rejectWithValue }) => {
        const api = '/app/versions/get?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));

        if (response.data.result) {
            return response.data.data.versions;
        } else {
            return rejectWithValue('Failed to fetch data');
        }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const createAppsVersions = createAsyncThunk(
    'servicesAppsVersions/createAppsVersions',
    async (data, { rejectWithValue }) => {
        const api = '/app/versions/create?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));

        if (response.data.result) {
            return data;
        } else {
            return rejectWithValue('Failed to fetch data');
        }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const updateAppsVersions = createAsyncThunk(
    'servicesAppsVersions/updateAppsVersions',
    async (data, { rejectWithValue }) => {
        const api = '/app/versions/update?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));

        if (response.data.result) {
            return data;
        } else {
            return rejectWithValue('Failed to fetch data');
        }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const deleteAppsVersions = createAsyncThunk(
    'servicesAppsVersions/deleteAppsVersions',
    async (data, { rejectWithValue }) => {
        const api = '/app/versions/delete?XDEBUG_SESSION_START=MyVSCode';

        try {
        const response = await apiInstance.post(api, JSON.stringify({ data }));

        if (response.data.result) {
            return data;
        } else {
            return rejectWithValue('Failed to fetch data');
        }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

const initialState = {
    getAppsVersionsStatus: null,
    createAppsVersionsStatus: null,
    updateAppsVersionsStatus: null,
    deleteAppsVersionsStatus: null,
    appsVersions: [],
};

const servicesAppsVersionsSlice = createSlice({
    name: 'servicesAppsVersions',
    initialState,
    extraReducers: (builder) => {
        builder
            // getAppsVersions
            .addCase(getAppsVersions.pending, (state) => { state.getAppsVersionsStatus = 'pending'; })
            .addCase(getAppsVersions.fulfilled, (state, action) => { state.getAppsVersionsStatus = 'fulfilled'; state.appsVersions = action.payload; })
            .addCase(getAppsVersions.rejected, (state) => { state.getAppsVersionsStatus = 'rejected'; })

            // createAppsVersions
            .addCase(createAppsVersions.pending, (state) => { state.createAppsVersionsStatus = 'pending'; })
            .addCase(createAppsVersions.fulfilled, (state, action) => { state.createAppsVersionsStatus = 'fulfilled'; state.appsVersions.push(action.payload); })
            .addCase(createAppsVersions.rejected, (state) => { state.createAppsVersionsStatus = 'rejected'; })

            // updateAppsVersions
            .addCase(updateAppsVersions.pending, (state) => { state.updateAppsVersionsStatus = 'pending'; })
            .addCase(updateAppsVersions.fulfilled, (state, action) => {
                state.updateAppsVersionsStatus = 'fulfilled';
                state.appsVersions = state.appsVersions.map(app =>
                    app.id === action.payload.id ? {
                        ...app,
                        min_version: action.payload.min_version,
                        recommended_version: action.payload.recommended_version,
                        app_link: action.payload.app_link,
                        is_default_link: action.payload.is_default_link,
                        store_key: action.payload.store_key,
                    } : app
                );
            })
            .addCase(updateAppsVersions.rejected, (state) => { state.updateAppsVersionsStatus = 'rejected'; })

            // deleteAppsVersions
            .addCase(deleteAppsVersions.pending, (state) => { state.deleteAppsVersionsStatus = 'pending'; })
            .addCase(deleteAppsVersions.fulfilled, (state, action) => {
                state.deleteAppsVersionsStatus = 'fulfilled';
                state.appsVersions = state.appsVersions.filter(app => app.id !== action.payload.id);
            })
            .addCase(deleteAppsVersions.rejected, (state) => { state.deleteAppsVersionsStatus = 'rejected'; })
            
            // PURGE
            .addCase(PURGE, () => { return initialState; });
    },
    reducers: {},
});

export const {} = servicesAppsVersionsSlice.actions;

export default servicesAppsVersionsSlice.reducer;
